import { render, staticRenderFns } from "./navigation-button.vue?vue&type=template&id=280d8d5a&"
import script from "./navigation-button.vue?vue&type=script&lang=js&"
export * from "./navigation-button.vue?vue&type=script&lang=js&"
import style0 from "./navigation-button.vue?vue&type=style&index=0&id=280d8d5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports